import React from 'react';

import Alert from '@glu/alerts-react';
import { withStyles } from '@glu/theming';

import withLocale from 'components/withLocale/withLocale';
import { ALERTVARIATIONS } from 'constants.js';

import styles from './BasicGridErrorBoundary.styles';

interface Props {
  locale: { [key: string]: string };
  classes: { [key: string]: string };
  children: React.ReactNode;
}

interface IState {
  hasError: boolean;
  error: { [key: string]: string };
}

// There is an error in Glu Data-components. It is in the 'handleSelectChange' funciton of NumberFilter.jsx.
// We are on an old version of the component and would be a large effort to update.
// This is to prevent the whole grid from crashing until we can
// update the Glu Data-components and Glu Grid.
const ignoredError = "Cannot read properties of undefined (reading 'id')";
class ErrorBoundary extends React.Component<Props, IState> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: {} };
  }

  static getDerivedStateFromError(error = {}) {
    return { hasError: true, error };
  }

  render() {
    const { classes, locale } = this.props;

    if (this.state.hasError && !this.state.error?.message?.includes(ignoredError)) {
      return (
        <Alert
          className={classes.errorAlert}
          dataQa="grid-error-alert"
          dismissible={false}
          message={locale['common.somethingWentWrong']}
          variant={ALERTVARIATIONS.ERROR}
        />
      );
    }

    return this.props.children;
  }
}

const StyledErrorBoundary = withStyles(styles)(ErrorBoundary);

export default withLocale(StyledErrorBoundary);
